export const PROPERTY_SCHEMAS = [
  { id: null, name: '\xa0' },
  { id: 'immobiliare.it', name: 'Immobiliare.it' },
  { id: 'idealista.it', name: 'Idealista.it' },
  { id: 'external', name: 'Esterno' },
];
